import { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  Input,
  Button,
  Select,
  Tooltip,
  Table,
  Tag,
  message,
} from "antd";
import { usrRole } from "../../utils/dataUtil";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import {
  req_page_nms_noteproject,
  req_add_nms_noteproject_tag,
  req_del_nms_noteproject_tag,
  req_add_nms_noteproject_btnlog,
} from "../../api";

class AllNotebooklmList extends Component {
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [
      {
        LmUrl:
          "https://notebooklm.google.com/notebook/921c3f5c-e244-49af-8beb-e3667f4918fe",
        NoteTitle: "資料庫系統與管理",
        NoteTypeName: "課程講義",
        Uid: "16DB0A7F33894810B91C16E9B3AFB946",
        ApplicableDeparts: "資訊管理學系",
        NoteDescription:
          "內容涵蓋了資料庫的基本概念、使用資料庫的好處、資料庫管理系統（DBMS）的安裝與常見種類，以及關聯式資料庫的理論與實作",
        AuthorName: "杜主民老師",
        NoteStatusName: "已公開",
      },
      {
        LmUrl:
          "https://notebooklm.google.com/notebook/ac3413bf-e2bc-4d84-a1d4-78a210958564",
        NoteTitle: "長期買進：周冠男的自制力投資課",
        NoteTypeName: "文件彙整",
        Uid: "F7094B636E4E41AC83C6497A74A2C94F",
        ApplicableDeparts: "不分學系",
        NoteDescription:
          "由周冠男教授撰寫的投資書籍《長期買進》的概述和討論。 強調理性投資策略，分析常見的行為偏差，並評估不同投資工具的優缺點",
        AuthorName: "曾秋榮老師",
        NoteStatusName: "已公開",
      },
    ],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",
    isShowModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  componentWillUnmount() {
    //window.removeEventListener("resize", this.resize.bind(this))
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_nms_noteproject(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_btn_log_api = async (Uid, BtnName, BtnDescription) => {
    const { token, userCode } = this.props.user;
    const log = {
      BtnName: BtnName,
      NoteUid: Uid,
      ReaderId: userCode,
      BtnDescription: BtnDescription,
    };
    try {
      const result = await req_add_nms_noteproject_btnlog(log, token);
      if (result.status === "success") {
        console.log("已記錄按鈕操作");
      }
    } catch (error) {
      message.error("網路連線不穩定，請稍後再試");
    }
  };

  add_tag_api = async (uid) => {
    const { token, userCode } = this.props.user;
    try {
      const item = {
        ReaderId: userCode,
        NoteUid: uid,
      };
      const result = await req_add_nms_noteproject_tag(item, token);
      if (result.status === "success") {
        message.success("已加入最愛");
        this.api_btn_log_api(item, "加入最愛", "使用者將筆記加入最愛清單");
        this.api_page_items(this.current);
      }
    } catch (error) {
      message.error("網路連線不穩定，請稍後再試");
    }
  };

  del_tag_api = async (uid) => {
    const { token, userCode } = this.props.user;
    const item = {
      ReaderId: userCode,
      NoteUid: uid,
    };
    try {
      const result = await req_del_nms_noteproject_tag(userCode, uid, token);
      if (result.status === "success") {
        message.success("已移除最愛");
        this.api_btn_log_api(item, "移除最愛", "使用者將筆記從最愛清單移除");
        this.api_page_items(this.current);
      }
    } catch (error) {
      message.error("網路連線不穩定，請稍後再試");
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "操作",
        width: 40,
        dataIndex: "LmUrl",
        align: "center",
        render: (field, item) => {
          return (
            <>
              <div>
                <a
                  href={field}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => this.handle_btn_log(item)}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fas fa-book"></i> 前往瀏覽
                </a>
              </div>
              <div style={{ marginTop: "3px" }}>
                <button
                  href={field}
                  onClick={() => this.handle_btn_event(item)}
                  target="_blank"
                  rel="noreferrer"
                  className={
                    item.MyTag === "TAG"
                      ? "btn btn-danger btn-sm"
                      : "btn btn-warning btn-sm"
                  }
                >
                  <i className="fas fa-heart"></i>{" "}
                  {item.MyTag === "TAG" ? "已加最愛" : "加入最愛"}
                </button>
              </div>
            </>
          );
        },
      },
      {
        title: "分類",
        responsive: ["md"],
        width: 40,
        dataIndex: "NoteTypeName",
        align: "center",
        render: (field) => {
          return (
            <div>
              <Tag color={this.style_switch_color_tag("TYPE_COURSE", field)}>
                {field}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "筆記名稱",
        dataIndex: "NoteTitle",
        width: 80,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "筆記說明",
        responsive: ["md"],
        dataIndex: "NoteDescription",
        width: 100,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.2em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "適用對象",
        responsive: ["md"],
        dataIndex: "ApplicableDeparts",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "筆記作者",
        responsive: ["md"],
        dataIndex: "AuthorName",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_btn_event = (item) => {
    const { MyTag, Uid } = item;
    const type = MyTag === "TAG" ? "del_tag" : "add_tag";
    switch (type) {
      case "add_tag":
        this.add_tag_api(Uid);
        break;
      case "del_tag":
        this.del_tag_api(Uid);
        break;
      default:
    }
  };

  handle_btn_log = (item) => {
    const BtnName = "前往瀏覽";
    const BtnDescription = `使用者點擊筆記瀏覽按鈕`;
    this.api_btn_log_api(item.Uid, BtnName, BtnDescription);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "delete":
        // const { activityNid } = item
        // Modal.confirm({
        //     title: `您確定刪除此筆數據`,
        //     onOk: () => {
        //         this.api_delete_item(activityNid)
        //     }
        // })
        break;
      case "download":
        break;
      default:
    }
  };

  style_switch_color_tag(column, param) {
    switch (column) {
      case "TYPE_COURSE":
        switch (param) {
          case "文件彙整":
            return "#e1a517ff";
          case "課程講義":
            return "#34495e";
          default:
            return "default";
        }
      default:
        return "blue";
    }
  }

  /////////////////////////////////////////////////////////////
  render() {
    const { items, loading, searchField, searchValue, pagination } = this.state;
    const title = (
      <>
        <Select
          value={searchField}
          style={{ width: 100 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">請選擇</Select.Option>
          <Select.Option value="NoteTitle">筆記名稱</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
      </>
    );
    return (
      <Card title={title}>
        {" "}
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AllNotebooklmList);
